import React from 'react';
import PropTypes from 'prop-types';
import image from '../../assets/images/news.jpg';
import { withTranslation } from 'react-i18next';
import { GatsbyImage } from 'gatsby-plugin-image'

const HeaderImage = ({t, image, alt, height }) => {
  let altText = alt;

  return (
    <header className={` header-image ${height}`} >
      <GatsbyImage image={image.gatsbyImageData} alt={altText} className={height} loading="eager"/>
    </header>
  );
};

HeaderImage.defaultProps = {
  height: '',
  alt: '',
  image: image,
};

HeaderImage.propTypes = {
  height: PropTypes.oneOf(['high', '']),
  image: PropTypes.object.isRequired,
  alt: PropTypes.string,
};

export default withTranslation()(HeaderImage);
